var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-app":""}},[_c('v-app-bar',{attrs:{"light":""}},[_c('v-img',{staticClass:"mx-2",attrs:{"src":require("@/assets/pumas-logo.png"),"max-height":"100","max-width":"100","contain":""}}),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }